import { pick } from 'ramda'

import { EVENT_TYPES, MESSAGE_TYPES } from '../constants'

const EVENT_TYPE_TO_MESSAGE_TYPE = {
  [EVENT_TYPES.CAPTURE_CREATED]: MESSAGE_TYPES.NEW_INVOICE.id,
  [EVENT_TYPES.COLLECTION_CREATED]: MESSAGE_TYPES.NEW_INVOICE.id,
  [EVENT_TYPES.COLLECTION_DUE_SOON]: MESSAGE_TYPES.MONTHLY_INVOICE_DUE_SOON.id,
  [EVENT_TYPES.ORDER_DUE_SOON]: MESSAGE_TYPES.ORDER_DUE_SOON.id,
}

const normalizeNotification = (notificationResponse): any => ({
  ...pick(['notificationEventId', 'read', 'occurredTime'], notificationResponse),
  messageType: EVENT_TYPE_TO_MESSAGE_TYPE[notificationResponse.eventType],
})

export const normalizeNotifications = (notificationsResponse): any =>
  notificationsResponse.map(normalizeNotification)

export default {
  normalizeNotifications,
}
